<template>
  <div class="container mt-3">
    <header>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">
    </header>
    <div class="container mt-5 mb-5">
      <div class="icon-container container-menu">
        <i v-if="clone === true" class="fas fa-plus" @click="openModalAddItemHistorico()" />
      </div>
    </div>

    <table class="table">
      <tbody>
        <tr v-for="(item, index) in listaItensHistorico" :key="index">
          <td>{{ item.detalhe }}</td>

          <td style="width: 104px" v-if="clone === true">
            <button class="btn btn-primary" style="padding: 8px 13px 15px 13px;" @click="excluirItensHistorico(index)">
              <i style="font-size: 13px !important;" class="fa-solid fa-trash"></i>
            </button>
          </td>
        </tr>

        <tr v-if="!listaItensHistorico || listaItensHistorico.length === 0">
          <td>Nenhum item de histórico encontrado.</td>
        </tr>
      </tbody>
    </table>
    <div class="m-3 mt-5" role="group" aria-label="Basic example">
      <div class="row">
        <div class="col-8">
          <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/consulta-catalogo">
            <button type="button" id="vendas" class="footer-button btn btn-primary btn-return" data-mdb-ripple-init>
              VOLTAR
            </button>
          </a>
        </div>
      </div>
    </div>

    <!-- O Modal add item historico -->
    <div v-if="showModal" class="modal modal-add-itens-historico fade" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar item histórico</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>

          <div class="modal-body mb-4">
            <div class="col-12 col-sm-12 col-md-3 m-3">
              <div class="form-outline">
                <div class="textarea-container mt-4">
                  <label class="green-label" for="textareaId">Detalhe:</label>
                  <textarea rows="4" id="detalhe" class="input-modal text-area-historico" v-model="detalheNovoItem"
                    required></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="m-3 mt-5" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary"
                  style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button @click="salvarNovoItemHistorico()" type="button" id="gestao-carteira"
                  style="width: 205% !important;color:white !important"
                  class="footer-button btn btn-primary active save-btn" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as ajaxUtils from '@/utils/ajax';
import * as validadorUtils from '@/utils/validador';
import * as alertUtils from '@/utils/alert';


export default {
  name: 'Historico',
  data() {
    return {
      listaItensHistorico: [],
      showModal: false,

      listaItensHistorico: [],
      tipoNovoItem: "",
      detalheNovoItem: "",
      menuAtivo: "",
      itensHistorico: []
    };
  },
  props: {
    clone: { type: Boolean, required: true },
    idCatalogo: { type: String, required: true }
  },

  mounted() {
    this.buscarItensHitorico();
  },
  methods: {
    async buscarItensHitorico() {
      const urlApi =
        '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consulta-catalogo/' +
        this.idCatalogo;

      const data = await ajaxUtils.get(urlApi, false);
      if (!data) return;

      const historicos = data && data.historico ? data.historico : [];
      this.listaItensHistorico = [];

      if (Array.isArray(historicos) && historicos.length > 0) {
        const ultimoHistorico = historicos[historicos.length - 1];

        if (ultimoHistorico && ultimoHistorico.versao == null) {
          this.listaItensHistorico = (ultimoHistorico.itens || []).slice();
        }
      }

    },

    async excluirItensHistorico(index) {
      try {
        const urlApi =
          '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/apagar-item-historico/' +
          this.idCatalogo +
          '/' +
          index;

        const resp = await fetch(urlApi, { method: 'GET' });
        if (!resp.ok) throw new Error('Falha ao excluir item');

        await this.buscarItensHitorico();
      } catch (e) {
        console.error(e);
      }
    },

    async openModalAddItemHistorico() {
      this.showModal = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-itens-historico');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },

    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
    },

    async salvarNovoItemHistorico() {
      const bodyData = {
        "tipo": this.tipoNovoItem,
        "detalhe": this.detalheNovoItem
      };

      const camposObrigatorios = new Array('detalhe', 'campo "detalhe" do item histórico');

      const erro = validadorUtils.validarCamposObrigatorios(bodyData, camposObrigatorios);

      if (erro) {
        return;
      }


      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/criar-item-historico/' + this.idCatalogo;
      const requestOptions = {
        method: 'POST',
        body: JSON.stringify(bodyData),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };

      try {
        const response = await fetch(urlApi, requestOptions);

        if (response.ok) {
          alertUtils.alertSuccess("Item criado com sucesso!");
          this.buscarItensHitorico();
        } else {
          alertUtils.alertError("Erro ao criar item.");
        }
      } catch (error) {
        console.error('Erro ao salvar:', error);
        alertUtils.alertError('Erro ao salvar: ' + error.message);
      } finally {
        this.closeModal();
      }
      setTimeout(() => {
        this.buscarItensHitorico();
        this.detalheNovoItem = "";
      }, 1000);

    }
  }
}
</script>
